import AccountContent from "./Content";
import AccountSummary from "./Summary";

export const AccountStep = {
  Content: AccountContent,
  Summary: AccountSummary
}